<template>
  <div class="third special-details"
       v-loading='detailsLoading'>
    <div class="third-formOne">
      <div class="formOne-btn">
        <div class="btn-left">
          <span class="left-back-icon"
                @click="changeComponent">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>
          <span class="left-back-content">服务配置》{{ currentName }}专题</span>
        </div>
        <div class="btn-right">
          <el-button @click="resetForm"
                     class="btn-two"
                     type="default">重置</el-button>
          <el-button @click="commit"
                     class="btn-two"
                     type="primary"
                     v-el-disabel-repeat-click>保存</el-button>
        </div>
      </div>
      <el-form :model="ruleForm"
               ref="ruleForm"
               :rules="rules"
               label-width="86px"
               @validate="validateValue"
               :show-message="false">
        <div class="formOne-forms">
          <div class="forms-one"
               style="margin-top: 57px">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">基本信息</span>
              </div>
            </div>
            <div class="one-list">
              <el-form-item label="图片"
                            prop="bgFileList">
                <preview-card :ArrList="ruleForm.bgFileList"
                              @toPreview="previewPci"
                              @toRemvove="removePic"
                              preType="uploadOne"></preview-card>
                <el-upload class="list-upload-img"
                           ref="uploadOne"
                           :limit="1"
                           action="noUse"
                           accept=".jpg, .jpeg, .png, .gif"
                           :http-request="uploadOne"
                           :file-list="ruleForm.bgFileList"
                           :class="{ fileDisabled: ruleForm.bgFileList.length !== 0 }"
                           list-type="picture-card">
                  <i class="el-icon-plus"></i>
                  <div class="list-upload-title">点击上传</div>
                  <div slot="tip"
                       class="list-upload-tip">
                    20M以内，支持扩展名.png、.jpg、.jpeg、.gif。建议为1404*300px的矩形图片
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item label="名称"
                            prop="name">
                <el-input class="list-input elnumber"
                          step-strictly
                          :controls="false"
                          maxLength=30
                          v-model.trim="ruleForm.name"
                          placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="顺序"
                            prop="orderNum">
                <el-input-number class="list-input elnumber"
                                 :min="1"
                                 :max="9999"
                                 :step="1"
                                 step-strictly
                                 :controls="false"
                                 v-model="ruleForm.orderNum"
                                 placeholder="请输入正整数"></el-input-number>
              </el-form-item>
              <el-form-item label="查看权限"
                            prop="service_use_need_login">
                <el-tag style="margin: 0 4px"
                        v-for="tag in roleTags"
                        :key="tag.id"
                        @close="handleRoleClose(tag)"
                        closable>{{ tag.name }}</el-tag>
                <el-button style="height: 24px"
                           type="default"
                           icon="el-icon-plus"
                           @click="addTags('role')">新增</el-button>
              </el-form-item>
              <el-form-item label="专题状态"
                            prop="state">
                <el-radio-group class="list-input"
                                v-model="ruleForm.state">
                  <el-radio :label="1">开启</el-radio>
                  <el-radio :label="0">关闭</el-radio>
                  <!-- <el-radio :label="9">备选项</el-radio> -->
                </el-radio-group>
              </el-form-item>
              <el-form-item label="展示开始时间"
                            prop="startTime">
                <el-date-picker class="list-input"
                                v-model="ruleForm.startTime"
                                type="datetime"
                                :clearable='true'
                                @change="startTimeChange"
                                placeholder="请选择">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="展示结束时间"
                            prop="endTime">
                <el-date-picker class="list-input"
                                v-model="ruleForm.endTime"
                                @change="endTimeChange"
                                :clearable='true'
                                type="datetime"
                                placeholder="请选择，不选择为永久有效">
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">专题详情</span>
              </div>
            </div>
            <div class="one-list">
              <el-form-item label="专题内容"
                            prop="articleType">
                <el-radio-group class="list-input"
                                @change="GZHCardData = ''"
                                v-model="ruleForm.articleType">
                  <el-radio label="1">自定义</el-radio>
                  <el-radio label="2">指定公众号</el-radio>
                  <el-radio label="3">指定链接</el-radio>
                </el-radio-group>
              </el-form-item>
              <template v-if="ruleForm.articleType == 1">
                <el-form-item label="专题详情"
                              prop="http">
                  <div class="add-row">
                    <div>
                      <el-button icon="el-icon-plus"
                                 @click="crfw">插入服务</el-button>
                      <el-button icon="el-icon-plus"
                                 @click="crgzhxx">插入公众号消息</el-button>
                      <el-button icon="el-icon-plus"
                                 @click="crgzh(1)">插入公众号</el-button>
                    </div>
                    <el-button icon="el-icon-view"
                               @click="view">预览</el-button>
                  </div>
                  <wangEditor @getContent='getContent'
                              @getHtmlList='getHtmlList'
                              ref="wangEditor"> </wangEditor>
                </el-form-item>
              </template>
              <template v-if="ruleForm.articleType == 2">
                <el-form-item label="专题详情"
                              prop="http">
                  <div class="add-row">
                    <el-button icon="el-icon-plus"
                               @click="crgzh(2)">选择公众号</el-button>
                  </div>
                  <div class="assignGZh"
                       v-if="assignGZHCardData">
                    <div class="serveCard">
                      <div class="top">
                        <div class="left">
                          <img :src="assignGZHCardData.icon.split(',')[0]"
                               alt="" />
                        </div>
                        <div class="center">
                          <div class="center-top">{{assignGZHCardData.nickname}}</div>
                          <div class="center-bottom">{{assignGZHCardData.accountSubject}}</div>
                        </div>
                      </div>
                      <div class="bottom">
                        {{assignGZHCardData.description}}
                      </div>
                    </div>
                  </div>
                  <div style="fontSize: 12px; color: #bbb">
                    用户打开此专题时，页面将自动跳转至公众号主页面
                  </div>
                </el-form-item>
              </template>
              <template v-if="ruleForm.articleType == 3">
                <el-form-item label="专题详情链接"
                              prop="http">
                  <el-input class="list-input elnumber"
                            step-strictly
                            :controls="false"
                            v-model.trim="ruleForm.http"
                            :maxlength="1000"
                            placeholder="请输入完整的http(s)路径"></el-input>
                  <div style="fontSize: 12px; color: #bbb">
                    用户打开此专题时，页面将自动跳转至链接页面
                  </div>
                </el-form-item>
              </template>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <el-dialog class="serviceListTree"
               title="添加可见角色"
               :visible.sync="roleTreeDialogVisible"
               :close-on-click-modal="false"
               width="30%"
               v-el-drag-dialog>
      <el-tree :data="roleTree"
               show-checkbox
               default-expand-all
               node-key="id"
               ref="roleTree"
               highlight-current
               :props="{
          children: 'children',
          label: 'roleName',
        }"></el-tree>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="roleTreeDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="getCheckedKeys('roleTree')">确 定</el-button>
      </span>
    </el-dialog>
    <new-task-modal class="import-modal FWModal-modal"
                    :newModalVisible="FWModal"
                    @closeNewTask="closeAdd"
                    @addNewTask="agreeAdd"
                    :isLoading="isLoading"
                    :isbottom="true"
                    bottomText=""
                    agreeBtn="确定"
                    :modalTitle="tanchuangtitle">
      <div slot="content"
           class="FWModal-content"
           style="text-align: left">
        <div class="search"
             :style="{'margin':!fwFlag ? '60px 0 40px': '0'}">
          <el-input style="width: 350px"
                    placeholder="请输入服务名称"
                    @keyup.enter.native="searchFW"
                    v-model.trim="fwName">
            <i @click="searchFW"
               slot="suffix"
               class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <div class="FWlist"
             v-loading='FWloading'>
          <div v-if="fwList.length > 0"
               class="FWlistBox"
               infinite-scroll-disabled="disabled"
               v-infinite-scroll="load">
            <div class="FWlistBoxList">
              <div :class="serveCardData === item ? 'serveCardActivate' : ''"
                   class="serveCard"
                   @click="serveCard(item)"
                   v-for="(item, index) in fwList"
                   :key="index">
                <div class="left">
                  <img :src="item.serviceIcon"
                       alt="" />
                </div>
                <div class="center">
                  <div class="center-top">{{item.serviceName}}</div>
                  <!-- <div class="center-bottom">服务</div> -->
                </div>
                <div class="right">
                  <div class="right"><i class="el-icon-arrow-right"></i></div>
                </div>
              </div>
            </div>
            <p style="textAlign:center;color: #aaa;"
               v-if="loading">加载中...</p>
            <p style="textAlign:center;color: #aaa;"
               v-if="noMore">没有更多了</p>
          </div>
          <div class="noDataBox"
               v-if="fwList.length == 0 && fwFlag">
            <img class="noData"
                 src="@/assets/img/nosort.png"
                 alt="" />
            <div>未查询到相关服务</div>
          </div>
        </div>
      </div>
    </new-task-modal>
    <new-task-modal class="import-modal GZHModal-modal"
                    :newModalVisible="GZHModal"
                    @closeNewTask="GZHcloseAdd"
                    @addNewTask="GZHagreeAdd"
                    :isLoading="isLoading"
                    :isbottom="true"
                    bottomText=""
                    agreeBtn="保存"
                    :modalTitle="GZHtitle">
      <div slot="content"
           class="FWModal-content"
           style="text-align: left">
        <div class="search"
             :style="{'margin':!gzhFlag ? '60px 0 40px': '0'}">
          <el-input style="width: 350px"
                    placeholder="请输入公众号名称"
                    @keyup.enter.native="searchGZH"
                    v-model.trim="gzhName">
            <i @click="searchGZH"
               slot="suffix"
               class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <div class="FWlist"
             v-loading='FWloading'>
          <div v-if="gzhList.length > 0"
               class="FWlistBox"
               infinite-scroll-disabled="disabled2"
               v-infinite-scroll="load2">
            <div class="FWlistBoxList">
              <div :class="GZHCardData === item ? 'serveCardActivate' : ''"
                   class="serveCard"
                   @click="gzhCard(item)"
                   v-for="(item, index) in gzhList"
                   :key="index">
                <div class="top">
                  <div class="left">
                    <img :src="item.icon.split(',')[0]"
                         alt="" />
                  </div>
                  <div class="center">
                    <div class="center-top">{{item.nickname}}</div>
                    <div class="center-bottom">{{item.accountSubject}}</div>
                  </div>
                  <div class="right">
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="bottom">
                  {{item.description}}
                </div>
              </div>
            </div>
            <p style="textAlign: center;color: #aaa;"
               v-if="loading">加载中...</p>
            <p style="textAlign:center;color: #aaa;"
               v-if="noMore2">没有更多了</p>
          </div>
          <div class="noDataBox"
               v-if="gzhList.length == 0 && gzhFlag">
            <img class="noData"
                 src="@/assets/img/nosort.png"
                 alt="" />
            <div>未查询到相关公众号</div>
          </div>
        </div>
      </div>
    </new-task-modal>
    <addgzhxx ref="addModalRef"
              :addModalVisible="gzhxxModal"
              @closeAddModal="gzhxxModalClose"
              addModalTitle="插入公众号消息(每条消息仅能插入一次)"
              :addData="formData"
              :addItem="itemInfos"
              :addColumn="columnList"
              :addType="myAddType"
              :childrenList='childrenList'
              @resetAddForm="resetAddFormData"
              @agreeAddMember="addMemberPass">
    </addgzhxx>
    <preview-modal :previewModal="previewImageModal"
                   :previewImageUrl="dialogPreviewUrl"
                   @previewClose="previewImageModalClose">
    </preview-modal>
  </div>
</template>

<script>
import { itemDetailPort, updatePort } from "@/api/appSetting/appServiceSetting";
import Sortable from "sortablejs";
// import addOfficalAccounts from '../component/addOfficalAccounts'
import wangEditor from "../../wangEditor/index.vue";
import addgzhxx from "../../component/addgzhxx.vue";
import { uniqBy } from "lodash";
import { setStore, getStore } from "@/utils/store";
import {
  getEditor,
} from "@wangeditor/editor-for-vue";

export default {
  name: "formSeven",
  props: ["rowId"],
  data () {
    var validatePass = (rule, value, callback) => {
      if (this.roleTags.length == 0) {
        callback(new Error("请选择查看权限"));
      } else {
        // if (this.ruleForm.checkPass !== '') {
        // this.$refs.ruleForm.validateField('checkPass');
        // }
        callback();
      }
    };
    var http = (rule, value, callback) => {
      if (this.ruleForm.articleType == 3 && !value) {
        callback(new Error("请输入专题详情链接"));
      } else if (this.ruleForm.articleType == 3 && value) {
        var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确格式的链接"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var disabledDate = (time) => {
      console.log(time);
      return time.getTime() < new Date(this.ruleForm.endTime);
    };
    return {
      detailsLoading: true,
      FWloading: false,
      defaultContent: [],
      formData: {
        mpName: "",
        title: "",
        content: "",
        accountSubject: "",
      }, // 添加人员弹窗搜索项
      itemInfos: {
        mpName: {
          label: "所属公众号",
          placeholder: "请输入",
          type: "input",
        },
        title: {
          label: "消息标题",
          placeholder: "请输入",
          type: "input",
        },
        content: {
          label: "消息内容",
          placeholder: "请输入",
          type: "input",
        },
        accountSubject: {
          label: "账号主体",
          placeholder: "请输入",
          type: "input",
        },
      }, //
      columnList: [
        {
          column: "所属公众号",
          key: "mpName",
          needKeyValue: false,
          caseKey: "mpName",
        },
        {
          column: "标题",
          key: "title",
          needKeyValue: false,
          caseKey: "title",
        },
        {
          column: "内容",
          key: "content",
          needKeyValue: false,
          caseKey: "content",
        },
        {
          column: "链接",
          key: "redirectUrl",
          needKeyValue: false,
          caseKey: "redirectUrl",
        },
        {
          column: "账号主体",
          key: "accountSubject",
          needKeyValue: false,
          caseKey: "accountSubject",
        },
        {
          column: "账号类型",
          key: "mpType",
          needKeyValue: 'mpType',
          caseKey: "mpType",
        },
        {
          column: "发布人",
          key: "sendMsgUser",
          needKeyValue: false,
          caseKey: "sendMsgUser",
        },
        {
          column: "发布时间",
          key: "publishTime",
          needKeyValue: false,
          caseKey: "publishTime",
        },
      ],
      myAddType: "3",
      gzhxxModal: false,
      loading: false,
      fwList: [],
      fwTotal: '',
      gzhList: [],
      gzhTotal: '',
      fwName: "",
      gzhName: "",
      tanchuangtitle: "插入服务",
      GZHtitle: "插入公众号",
      FWModal: false,
      GZHModal: false,
      isLoading: false,
      previewImageModal: false, // 预览弹窗
      roleTreeDialogVisible: false, // 角色弹窗
      currentName: "新增",
      countNum: 1, //用于显示第一个错误
      addModalVisible: false,
      cpRowId: this.rowId,
      //   &********弹框******************************
      agreeNotice: {},

      ruleForm: {
        id: "",
        name: "",
        startTime: "",
        endTime: "",
        state: 1,
        articleType: "1",
        orderNum: undefined,
        bgFileList: [],
        http: '',
        imId:''
      },
      rules: {
        orderNum: [{ required: true, message: "请输入顺序", trigger: "blur" }],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        state: [{ required: true, message: "请选择专题状态", trigger: "blur" }],
        articleType: [
          { required: true, message: "请选择专题内容", trigger: "blur" },
        ],
        http: [
          { required: true, validator: http, trigger: "blur" },
        ],
        startTime: [
          { required: true, message: "请选择展示开始时间", trigger: "blur" },
        ],
        endTime: [
          { required: false, message: "请选择展示结束时间", trigger: "blur" },
        ],
        service_use_need_login: [
          { required: true, validator: validatePass, trigger: "blur" },
        ],
        bgFileList: [
          { required: true, message: "请上传图片", trigger: "blur" },
        ],
        // showName: [{ required: false, message: "请输入展示名称", trigger: "blur" }],
        // homeRow: [{ required: true, message: "请选择公众号消息集合展示位置", trigger: "change" }],
        // openAll: [{ required: true, message: "请选择公众号消息集合", trigger: "change" }]
      },
      currentTableData: [],
      uploadFilter: [".jpg", ".jpeg", ".png", ".gif"],
      fileList: [],
      dialogPreviewUrl: "",
      roleTree: [],
      roleTags: [],
      serveCardData: null,
      GZHCardData: null,
      specialDetailData: '',
      role_id: '',
      fwpageIndex: 1,
      gzhpageIndex: 1,
      gzhFlag: false,
      fwFlag: false,
      contentStr: '',
      html: '',
      assignGZHCardData: '',
      childrenList: [],
    };
  },
  components: {
    // addOfficalAccounts
    wangEditor,
    addgzhxx,
  },
  computed: {
    noMore () {
      return this.fwList.length >= this.fwTotal;
    },
    noMore2 () {
      return this.gzhList.length >= this.gzhTotal;
    },
    disabled () {
      return this.loading || this.noMore;
    },
    disabled2 () {
      return this.loading || this.noMore2;
    },
  },
  async created () {

    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    this.specialDetailData = getStore({
      name: "specialDetail",
      type: "session"
    });
    console.log(this.specialDetailData);
    if (this.specialDetailData) {
      this.currentName = '编辑'
      if (this.specialDetailData.articleType == 1) {
        this.defaultContent = JSON.parse(this.specialDetailData.contentStr)
      }
    }

    await this.init();
    if (this.specialDetailData) {
      await this.themeArticleDetail()
    }
    await this.getRolelist()
    // this.themeArticleMpInfoList(1)
    // console.log(this.specialDetailData);
    this.detailsLoading = false

  },
  mounted () { },
  watch: {
    rowId () {
      this.cpRowId = this.rowId;
    },
  },
  methods: {
    getHtmlList (list) {
      this.childrenList = list
      console.log('触发了');
    },
    startTimeChange () {
      if (!this.ruleForm.startTime) {
        return
      }
      if (this.ruleForm.startTime > new Date(this.ruleForm.endTime)) {
        this.ruleForm.startTime = ''
        this.$message.error('不可大于结束时间')
      }
    },
    endTimeChange () {
      console.log(this.ruleForm.endTime);
      if (!this.ruleForm.endTime) {
        return
      }
      if (this.ruleForm.endTime < new Date(this.ruleForm.startTime)) {
        this.ruleForm.endTime = ''
        this.$message.error('不可小于开始时间')
      }
    },
    getContent (html, arr) {
      console.log(html, arr);
      this.html = html
      this.contentStr = JSON.stringify(arr)
    },
    searchGZH () {
      if (!this.gzhName) return
      this.gzhList = []
      this.FWloading = true
      this.gzhpageIndex = 1
      this.themeArticleMpInfoList(this.gzhpageIndex)
    },
    async themeArticleServiceList (pageIndex) {
      let a = []
      this.roleTags.forEach(item => {
        a.push(item.id)
      })
      const { data: { result, status } } = await this.$store.dispatch('themeArticleServiceList', {
        "pageIndex": pageIndex,
        "pageSize": 6,
        "roles": a.join(','),
        name: this.fwName
      })
      if (status == 1000) {
        if (result.data) {
          this.fwList = this.fwList.concat(result.data)
        }
        this.fwFlag = true
        this.FWloading = false
        this.fwTotal = result.total
      } else {
        this.fwFlag = true
        this.loading = false
      }
    },
    async themeArticleMpInfoList (pageIndex) {
      const { data: { result, status } } = await this.$store.dispatch('themeArticleMpInfoList', {
        "pageIndex": pageIndex,
        "pageSize": 6,
        "nickname": this.gzhName, //公众号名称 模糊搜索
        "accountSubject": "", //账号主体
      })
      if (status == 1000) {
        console.log(this.gzhList);
        if (result.data) {
          this.gzhList = this.gzhList.concat(result.data)
        }
        this.gzhTotal = result.total
        this.gzhFlag = true
        this.FWloading = false
      } else {
        this.gzhFlag = true
        this.loading = false
      }
    },
    async themeArticleDetail () {
      const { data: { result, status, mag } } = await this.$store.dispatch('themeArticleDetail', {
        id: this.specialDetailData.id
      })
      if (status === 1000) {
        this.ruleForm = {
          id: result.id,
          name: result.name,
          startTime: result.startTime,
          endTime: result.endTime,
          state: result.status,
          articleType: result.articleType,
          orderNum: result.sort,
          bgFileList: [{ url: result.articlePic }],
          http:result.redirectUrl,
        }
        if (result.articleType == 1) {
          this.defaultContent = JSON.parse(result.contentStr)
          this.contentStr = result.contentStr
          this.html = result.content
          this.$refs.wangEditor.reset(this.defaultContent)
        } else if (result.articleType == 2) {
          this.assignGZHCardData = JSON.parse(result.content)
          this.ruleForm.imId = this.assignGZHCardData.imId
        }
        // else if (result.articleType == 3) {
        //   this.ruleForm.http = result.redirectUrl?result.redirectUrl:''
        // }
        this.role_id = result.viewPermission

      } else {
        this.$message.error(msg)
      }
      console.log(this.ruleForm);
      // console.log(data);
    },
    view () {
      this.$refs.wangEditor.view();
    },
    // 重置添加弹窗搜索条件
    resetAddFormData () {
      this.formData = {
        mpName: "",
        title: "",
        content: "",
        accountSubject: "",
      }; // 添加人员弹窗搜索项
      this.$refs.addModalRef.resetFormData();
    },
    // 成功新增人员
    addMemberPass (selectArr) {
      this.$refs.addModalRef.handleClose();
      selectArr.forEach(item => {
        this.$refs.wangEditor.crgzhxx(item);
      })
    },
    gzhxxModalClose () {
      this.formData = {
        mpName: "",
        title: "",
        content: "",
        accountSubject: "",
      }; // 添加人员弹窗搜索项
      this.gzhxxModal = false;
    },
    serveCard (item) {
      console.log(item);
      if (this.serveCardData == item) {
        this.serveCardData = null;
        return;
      }
      this.serveCardData = item;
    },
    gzhCard (item) {
      console.log(item);
      if (this.GZHCardData == item) {
        this.GZHCardData = null;
        return;
      }
      this.GZHCardData = item;
    },
    async load () {
      this.loading = true;
      await this.themeArticleServiceList(this.fwpageIndex += 1)
      this.loading = false;
    },
    async load2 () {
      this.loading = true;
      await this.themeArticleMpInfoList(this.gzhpageIndex += 1)
      this.loading = false;
    },
    searchFW () {
      if (!this.fwName) return
      this.FWloading = true
      this.fwpageIndex = 1
      this.fwList = []
      this.themeArticleServiceList(this.fwpageIndex)
    },
    GZHcloseAdd () {
      this.gzhFlag = false
      this.GZHModal = false;
      this.FWloading = false;
      this.GZHCardData = null;
      this.gzhName = ''
    },
    GZHagreeAdd () {
      if (this.GZHCardData != null) {
        if (this.GZHtitle == '选择公众号') {
          this.assignGZHCardData = this.GZHCardData
          this.GZHModal = false;
        } else {
          this.$refs.wangEditor.crgzh(this.GZHCardData);
          this.GZHModal = false;
        }
      } else {
        this.$message.error("请选择公众号");
      }

    },
    closeAdd () {
      this.fwFlag = false
      this.FWModal = false;
      this.FWloading = false;
      this.serveCardData = null;
      this.fwName = ''
    },
    agreeAdd () {
      if (this.serveCardData != null) {
        this.$refs.wangEditor.crfw(this.serveCardData);
        this.FWModal = false;
      } else {
        this.$message.error("请选择服务");
      }
    },
    crfw () {
      if (this.roleTags.length == 0) {
        this.$message.error('请选择查看权限')
        return
      }
      this.FWModal = true;
      this.fwList = []
    },
    crgzhxx () {
      this.gzhxxModal = true;
    },
    crgzh (i) {
      if (i == 1) {
        this.GZHtitle = "插入公众号";
      } else {
        this.GZHtitle = "选择公众号";
      }
      this.GZHModal = true;
      this.gzhpageIndex = 1
      this.gzhList = []
    },
    handleRoleClose (tag) {
      console.log(tag);
      const { roleTags } = this;
      console.log(roleTags);
      if (this.ruleForm.articleType == 1) {
        this.$refs.wangEditor.removeServer()
      }
      this.roleTags = roleTags.filter((item) => item !== tag);
    },
    getCheckedKeys (refName) {
      const getNode = this.$refs[refName].getCheckedNodes();
      const selectArr = getNode.map((item) => {
        if (item.roleId) {
          return {
            name: item.roleName,
            id: item.roleId,
          };
        }
      });
      if (selectArr != this.roleTags) {
        if (this.ruleForm.articleType == 1) {
          this.$refs.wangEditor.removeServer()
        }
      }
      this.roleTags = selectArr.filter((item) => item);
      this.roleTreeDialogVisible = false;
      console.log(this.roleTags);
    },
    addTags () {
      this.roleTreeDialogVisible = true;
      this.roleOrlabel = true;
      if (this.roleTags.length > 0) {
        const keys = this.roleTags.map((item) => item.id);
        // console.log(keys)
        this.$nextTick(() => {
          this.$refs.roleTree.setCheckedKeys(keys);
        });
      }
    },
    // 获取角色列表
    async init () {
      const res2 = await this.$store.dispatch("getServiceRoleList");
      if (res2.data.status === 1000) {
        const { result } = res2.data;
        this.roleTree = result;
        console.log(this.roleTree);
      } else {
        this.$message.error('获取角色列表失败')
      }
    },
    getRolelist () {
      let childrenList = []; // 整理角色列表 去除一级 只留二级数据
      this.roleTags = [];
      this.roleTree.forEach((element) => {
        element.children.forEach((ele) => {
          childrenList.push(ele);
        });
      });
      console.log(childrenList);
      console.log(this.role_id);
      this.role_id.split(",").forEach((element) => {
        let role = childrenList.map((item) => {
          if (item.roleId === element) {
            return {
              id: item.roleId,
              name: item.roleName,
            };
          }
        });
        console.log(role);
        role = role.filter((item) => item);
        role.forEach((ele) => this.roleTags.push(ele));
      });
    },
    // 关闭预览弹窗
    previewImageModalClose () {
      this.previewImageModal = false;
      this.dialogPreviewUrl = "";
    },
    // 预览
    previewPci (item) {
      // window.open(item.url)
      this.dialogPreviewUrl = item.url;
      this.previewImageModal = true;
    },
    removePic (item, type) {
      console.log(item, type);
      this.ruleForm.bgFileList = [];
    },
    // 上传失败
    hadleError (err) {
      this.$message.error(err);
    },
    // 上传一
    uploadOne (params) {
      this.facUpload(params, "uploadOne");
    },
    // 验证格式
    filterFileRes (testSuffix, uploadFilter) {
      let matchingCount = false;
      uploadFilter.forEach((element) => {
        // console.log(element)
        if (element === testSuffix) {
          matchingCount = true;
        }
      });
      return matchingCount;
    },
    // 上传
    async facUpload (params, item) {
      console.log(params, item);
      const Vm = this;
      try {
        const file = params.file;
        const isLt5M = file.size / 1024 / 1024 <= 20;
        let testSuffix = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
        // console.log(testSuffix)
        let res = this.filterFileRes(testSuffix, this.uploadFilter);
        if (!res) {
          this.$message.error("上传文件格式错误");
          Vm.ruleForm.bgFileList = [];
          return;
        }
        if (!isLt5M) {
          this.$message.error("上传文件大小不得大于20M");
          Vm.ruleForm.bgFileList = [];
          return;
        }
        Vm.isUploading = true;
        let reqData = new FormData();
        reqData.append("file", params.file);
        const facUpload = await Vm.$store.dispatch("fileUpload", reqData);
        console.log(facUpload);
        Vm.isUploading = false;
        if (facUpload.data.success === 1) {
          console.log(facUpload);
          let arr = []
          let obj = {
            url: ""
          };
          obj.url = facUpload.data.data[0].oUrl;
          arr.push(obj);
          Vm.ruleForm.bgFileList = arr;
          console.log(Vm.ruleForm.bgFileList);
        } else {
          Vm.ruleForm.bgFileList = [];
          Vm.$message.error(facUpload.data.msg);
        }
      } catch (error) {
        Vm.isUploading = false;
        console.log(error);
      }
    },
    // 验证
    validateValue (prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    // 提交表单
    commit () {
      console.log(1);
      console.log(this.ruleForm.articleType);
      this.countNum = 0;
      this.$nextTick(() => {
        console.log(1);
        this.$refs.ruleForm.validate((valid) => {
          console.log("valid", valid);
          if (valid) {
            this.countNum = 1;
            console.log(this.contentStr);
            if (this.ruleForm.articleType == 1) {
              const editor = getEditor('w-e-1');
              if (!editor.isEmpty()) {
                this.updateData()
              } else {
                this.$message.error('请输入专题详情')
              }
            } else if (this.ruleForm.articleType == 2) {
              if (this.assignGZHCardData) {
                this.updateData()
              } else {
                this.$message.error('请输入专题详情')
              }
            } else if (this.ruleForm.articleType == 3) {
              this.updateData()
            }
          } else {
            return false;
          }
        });
      });
    },
    //表单重置
    resetForm () {
      this.$refs.ruleForm.clearValidate();
      this.ruleForm = {
        id: "",
        name: "",
        startTime: "",
        endTime: "",
        state: 1,
        articleType: "1",
        orderNum: undefined,
        bgFileList: [],
        http: '',
      }
      this.roleTags = []
      // this.roleTree = []
      if (this.specialDetailData) {
        this.$nextTick(() => {
          this.themeArticleDetail();
          this.getRolelist()
        });
      } else {
        this.$refs.roleTree.setCheckedKeys([]);
        this.init();
        this.$refs.wangEditor.reset([
          {
            type: "paragraph",
            children: [{ text: "" }],
          },
        ])
      }

    },
    async updateData () {
      let roleID = []
      this.roleTags.forEach(item => {
        roleID.push(item.id)
      })
      console.log(this.assignGZHCardData);
      const {
        data: { result, msg, status },
      } = await this.$store.dispatch('themeArticleSaveOrUpdate', {
        "id": this.ruleForm.id,//主键ID
        "articlePic": this.ruleForm.bgFileList[0].url,//专题配图URL
        "name": this.ruleForm.name,//专题名称
        "articleType": this.ruleForm.articleType,//专题文章类型
        "viewPermission": roleID.join(','),//可见角色
        "sort": this.ruleForm.orderNum,//顺序
        "status": this.ruleForm.state,//状态
        "startTime": this.ruleForm.startTime,//专题开始时间
        "content": this.ruleForm.articleType == 1 ? this.html : this.ruleForm.articleType == 2 ? this.assignGZHCardData : '',//专题开始时间
        "contentStr": this.contentStr,//专题开始时间
        "endTime": this.ruleForm.endTime,//专题结束时间
        "mpImId": this.ruleForm.articleType == 2?this.assignGZHCardData.imId:'',//专题结束时间
        "redirectUrl":this.ruleForm.articleType == 3?this.ruleForm.http:'' ,//专题结束时间
      });
      if (status === 1000) {
        this.$message.success("操作成功");
        this.changeComponent();
        console.log("结果", result);
        return;
      }
      return this.$message.error(msg);
    },
    // 改变index页面的component的值
    changeComponent () {
      this.$emit("changeComponent", "special");
    },
  },
};
</script>
<style lang="scss">
@import "@/styles/wangEditor/modal.scss";
.special-details {
  .list-upload-img {
    .el-upload--picture-card {
      width: 351px !important;
      height: 71px !important;
      line-height: 56px !important;
      // .list-upload-title{
      //   top: ;
      // }
    }
  }
  .pre-list-pic-card {
    .card-img {
      width: 351px;
      height: 71px;
    }
    .card-span {
      width: 351px;
      height: 71px;
      line-height: 70px;
    }
  }
  .el-upload-list--picture-card {
    display: none !important;
  }
  .fileDisabled {
    .el-upload--picture-card {
      display: none;
    }
  }
  .elnumber {
    .el-input {
      input {
        text-align: left;
      }
    }
  }
  .multi-rows,
  .single-row {
    display: inline-block;
    font-size: 12px;
    padding-left: 8px;
    color: #828d9a;
  }
  .add-row {
    margin-bottom: 15px;
    font-size: 12px;
    color: rgb(46, 63, 87);
    display: flex;
    justify-content: space-between;
    .el-button {
      margin-left: 0 !important;
      margin-right: 10px;
    }
  }
  .rows-copy {
    padding-left: 8px;
    color: #2d8cf0;
    cursor: pointer;
  }
  .single-row {
    min-width: 292px;
  }
  .row-goto {
    color: #2d8cf0;
    cursor: pointer;
  }
  .multi-rows {
    width: 676px;
  }
}
.serviceListTree {
  .el-dialog__header {
    border-bottom: 1px solid #d9d9d9;
  }
  .el-dialog__footer {
    border-top: 1px solid #d9d9d9;
  }
  .el-dialog__body {
    height: 400px;
    overflow-y: auto;
  }
}
</style>
